import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import { UserSelector } from 'components/AutocompletePopup'
import mentionStyles from '../mentions.module.scss'

interface MentionListProps {
    items: any[]
    command: (item: any) => void
    editor: any
}

const MentionList = forwardRef<any, MentionListProps>((props, ref) => {
    const [selectedIndex, setSelectedIndex] = useState(0)

    const selectItem = (index: number) => {
        const item = props.items[index]
        if (item && !item.isNoResults) {
            props.command(item)
        }
    }

    const upHandler = () => {
        setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length)
    }

    const downHandler = () => {
        setSelectedIndex((selectedIndex + 1) % props.items.length)
    }

    const enterHandler = () => {
        selectItem(selectedIndex)
    }

    useEffect(() => setSelectedIndex(0), [props.items])

    useImperativeHandle(ref, () => ({
        onKeyDown: ({ event }: { event: KeyboardEvent }) => {
            if (event.key === 'ArrowUp') {
                upHandler()
                return true
            }

            if (event.key === 'ArrowDown') {
                downHandler()
                return true
            }

            if (event.key === 'Enter' || event.key === 'Tab') {
                enterHandler()
                return true
            }

            return false
        },
    }))

    return (
        <div className={mentionStyles.mentionList}>
            {props.items.length ? (
                props.items.map((item, index) => (
                    <div
                        className={`${mentionStyles.mentionItem} ${
                            index === selectedIndex ? mentionStyles.selected : ''
                        }`}
                        key={item.id || index}
                        onClick={() => selectItem(index)}
                    >
                        {item.triggerType === 'model' ? (
                            // Model mention display
                            <div className={mentionStyles.modelItem} data-item-type="model">
                                <span className={mentionStyles.modelPrefix}>@@</span>
                                <span className={mentionStyles.modelName}>{item.content}</span>
                            </div>
                        ) : (
                            // User mention display
                            <UserSelector user={item} />
                        )}
                    </div>
                ))
            ) : (
                <div className={mentionStyles.mentionItem}>No results</div>
            )}
        </div>
    )
})

MentionList.displayName = 'MentionList'

export default MentionList
